module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEdit) ? _c('editor', {
    attrs: {
      "review": _vm.reviewModel
    },
    on: {
      "close": _vm.closeEditor
    }
  }) : _c('div', {
    staticClass: "review main hr"
  }, [_c('div', {
    staticClass: "review__avatar-wrap"
  }, [_c('img', {
    staticClass: "review__avatar",
    attrs: {
      "src": require("../../assets/img/review-user.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "review__content"
  }, [_c('div', {
    staticClass: "review__inner review__inner_flex"
  }, [_c('div', {
    staticClass: "review__title-box"
  }, [_c('div', {
    staticClass: "review__user-name bold"
  }, [_vm._v(_vm._s(_vm.value.created_by.first_name) + " " + _vm._s(_vm._f("one")(_vm.value.created_by.last_name)))]), _vm._v(" "), _c('div', {
    staticClass: "review__title bold"
  }, [_vm._v(_vm._s(_vm.value.title))])]), _vm._v(" "), _c('div', {
    staticClass: "review__rating-box"
  }, [_c('div', {
    staticClass: "review__rating-stars"
  }, [_c('stars', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.value.mark),
      callback: function($$v) {
        _vm.$set(_vm.value, "mark", $$v)
      },
      expression: "value.mark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "review__date"
  }, [_vm._v(_vm._s(_vm._f("ago")(_vm.value.created_at)))])])]), _vm._v(" "), _c('div', {
    staticClass: "review__inner"
  }, [_c('p', {
    staticClass: "review__paragrahp"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.value.text) + "\n\t\t\t")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "review-btn_wrap"
  }, [_c('a', {
    staticClass: "review__link",
    on: {
      "click": _vm.openReply
    }
  }, [_vm._v("Ответить")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.value.children), function(reply, i) {
    return _c('div', {
      staticClass: "review",
      class: {
        'hr': i !== _vm.value.children.length - 1
      }
    }, [_c('div', {
      staticClass: "review__avatar-wrap review__avatar-wrap_answer"
    }, [_c('img', {
      staticClass: "review__avatar",
      attrs: {
        "src": require("../../assets/img/review-user.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "review__content"
    }, [_c('div', {
      staticClass: "review__inner review__inner_flex review__inner_answer"
    }, [_c('div', {
      staticClass: "review__title-box"
    }, [_c('div', {
      staticClass: "review__user-name review__user-name_answer bold"
    }, [_vm._v("Антотина Юрьевна")]), _vm._v(" "), _c('div', {
      staticClass: "review__title review__title_answer bold"
    }, [_vm._v("Советую")])])]), _vm._v(" "), _c('div', {
      staticClass: "review__inner"
    }, [_c('p', {
      staticClass: "review__paragrahp"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(reply.text) + "\n\t\t\t\t\t\t")])])])])
  }), _vm._v(" "), (_vm.isReply) ? _c('form', {
    staticClass: "review-answer-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendReply($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyModel.text),
      expression: "replyModel.text"
    }],
    staticClass: "review-form__field review-form__field_textarea",
    attrs: {
      "placeholder": "Введите текст"
    },
    domProps: {
      "value": (_vm.replyModel.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.replyModel, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-btn review-section__btn basic-btn_review-answer"
  }, [_c('input', {
    staticClass: "basic-btn__item",
    attrs: {
      "type": "submit",
      "value": "Ответить"
    }
  })])]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30dc5ca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reviews/Review.vue
// module id = 599
// module chunks = 0